import React from 'react';

import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useSalesOrderIdContext } from '../../../../../../../orders/context/sales-order-id-context-provider';
import { useGetAddressValidationLink } from '../use-shipment-details-address';
import { ValidateButton } from './validate';
import { RevertButton } from './revert';

const AddressActions = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();
  const {
    marketplaceShipTo,
    fulfillmentPlanShipTo,
    isUnVerified,
    isErrorOrWarningState,
    isShippedStatus,
    doesFpShipToMatchMarketplace,
    isVerified,
  } = useGetAddressValidationLink(fulfillmentPlanId, salesOrderId);
  const isUnverifiedOrHasValidationError = isUnVerified || isErrorOrWarningState;
  const canRevert = !doesFpShipToMatchMarketplace && isVerified;

  if (isUnverifiedOrHasValidationError) {
    return <ValidateButton fulfillmentPlanId={fulfillmentPlanId} isShippedStatus={isShippedStatus} shipTo={fulfillmentPlanShipTo} />;
  }
  if (canRevert) {
    return <RevertButton fulfillmentPlanId={fulfillmentPlanId} isShippedStatus={isShippedStatus} shipTo={marketplaceShipTo} />;
  }

  return null;
};

export { AddressActions };
